module.exports = __webpack_public_path__ + "static/media/127-botswana.b3573fe2.svg";